<template>
  <PageContainer title="Listar Turmas">
    <Box class="turmas-container" space="medium">
      <div class="header">
        <form @submit.prevent="updateTurmas">
          <SingleDate
            legend="Data"
            :modelValue="data"
            @update:modelValue="$event => (this.data = $event)"
            :disabled="loading"
          />

          <Button type="submit" text="Atualizar Turmas" color="secondary" :disabled="loading">
            <Cached :size="18" />
          </Button>
        </form>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Input
              :modelValue="agrupamento"
              @update:modelValue="$event => (this.agrupamento = $event)"
              legend="ID do agrupamento"
              placeholder="ID do agrupamento"
              :disabled="loading"
            />

            <Period
              class="input-data"
              legend="Data"
              :firstModelValue="dataIni"
              @update:firstModelValue="$event => (this.dataIni = $event)"
              :secondModelValue="dataFim"
              @update:secondModelValue="$event => (this.dataFim = $event)"
              :disabled="loading"
            />
          </div>
          <div class="inputs-row">
            <Select
              :options="tiposOptions"
              legend="Tipo de aula"
              placeholder="Tipo de aula"
              :modelValue="tipo"
              @update:modelValue="$event => (this.tipo = $event)"
              :disabled="loading"
            />

            <Select
              :options="statusOptions"
              legend="Status"
              placeholder="Status"
              :modelValue="status"
              @update:modelValue="$event => (this.status = $event)"
              :disabled="loading"
            />
          </div>
        </div>

        <div class="buttons">
          <Button
            type="button"
            @handle:click="clearInputs"
            text="Limpar"
            :fill="false"
            color="danger"
            :disabled="loading"
          >
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div v-if="loading" class="d-flex justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SpringSpinner'"
          :color="'#1C2D5A'"
          :size="80"
          class="mx-2"
        >
        </component>
      </div>

      <template v-else-if="turmas.length > 0 && !loading">
        <div class="table-container">
          <Paginate
            :total-pages="paginationData.lastPage"
            :current-page="paginationData.currentPage"
            @page-changed="fetchTurmas"
          />

          <Table
            :headers="[
              'Agrupamento',
              'Início',
              'Fim',
              'Alunos Regulares',
              'Alunos para Reposição',
              'Virtual',
              'Status',
              'Ações',
            ]"
          >
            <tr v-for="turma in turmas" :key="turma.id_turma_teorica">
              <td>{{ turma.id_agrupamento }}</td>
              <td>{{ utils.formatDate(turma.data_inicio) }}</td>
              <td>{{ utils.formatDate(turma.data_fim) }}</td>
              <td>{{ turma.quantidade_alunos }}</td>
              <td>{{ turma.alunos_reposicao }}</td>
              <td v-if="turma.virtual">Sim</td>
              <td v-else>Não</td>
              <td>{{ turma.status }}</td>
              <td>
                <div class="actions">
                  <div>
                    <IconButton
                      @handle:click="openInfoModal(turma.id_turma_teorica)"
                      color="secondary"
                      title="Ver informações da turma"
                      :disabled="loadingActions"
                    >
                      <InformationOutline :size="19" />
                    </IconButton>
                  </div>
                </div>
              </td>
            </tr>
          </Table>
        </div>

        <div class="footer">
          <Button
            type="button"
            @handle:click="openExportModal"
            text="Baixar relatório de turmas"
            :fill="false"
            color="primary"
            :disabled="loading"
          >
            <TrayArrowDown :size="18" />
          </Button>
        </div>
      </template>
    </Box>

    <InfoModal ref="infoModal" @reload="fetchTurmas" />

    <ExportModal
      ref="exportModal"
      type="reduced"
      @submit:export="submitExport"
      :loading="exportLoading"
    />
  </PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import _export from '../../services/export'
import utils from '../../services/utils'
import Box from '../core/Box'
import Button from '../core/Button'
import IconButton from '../core/IconButton'
import Input from '../core/Input'
import PageContainer from '../core/PageContainer'
import Paginate from '../core/Paginate'
import Period from '../core/Period'
import Select from '../core/Select'
import SingleDate from '../core/SingleDate'
import Table from '../core/Table'
import ExportModal from '../export/ExportModal'
import InfoModal from './InfoModal'

import AccountOutline from 'icons/AccountOutline'
import Cached from 'icons/Cached'
import CameraOutline from 'icons/CameraOutline'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import InformationOutline from 'icons/InformationOutline'
import Magnify from 'icons/Magnify'
import TrayArrowDown from 'icons/TrayArrowDown'

export default {
  name: 'ListagemTurmas',
  components: {
    ...spinners,
    PageContainer,
    Box,
    SingleDate,
    Button,
    Input,
    Period,
    Select,
    Table,
    Paginate,
    IconButton,
    InfoModal,
    ExportModal,

    Cached,
    Magnify,
    CloseCircleOutline,
    TrayArrowDown,
    InformationOutline,
    AccountOutline,
    CameraOutline,
  },
  data() {
    return {
      idRole: localStorage.id_role,
      utils: utils,
      data: '',
      agrupamento: '',
      dataIni: '',
      dataFim: '',
      tipo: '',
      status: '',
      presenca: '',
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      filters: {},
      turma: null,
      turmas: [],
      tiposOptions: [
        {
          value: null,
          text: 'Todos',
        },
        {
          value: '1',
          text: 'Virtual',
        },
        {
          value: '2',
          text: 'Presencial',
        },
      ],
      statusOptions: [
        {
          value: null,
          text: 'Todos',
        },
        {
          value: '1',
          text: 'Pendente',
        },
        {
          value: '2',
          text: 'Confirmado',
        },
        {
          value: '3',
          text: 'Realizada',
        },
        {
          value: '4',
          text: 'Finalizada',
        },
        {
          value: '5',
          text: 'Cancelada',
        },
      ],
      loading: false,
      loadingActions: false,
      exportLoading: false,
    }
  },
  methods: {
    async fetchTurmas(page = 1) {
      this.loading = true

      const params = {
        id_turma: null,
        id_agrupamento: this.agrupamento,
        data_inicio: this.dataIni,
        data_fim: this.dataFim,
        alunos_regulares: null,
        turma_virtual: this.tipo,
        turma_status: this.status,
      }

      this.filters = params

      await this.$http
        .get(
          `${urlApi}/turmas/paginacao/${null}/${this.agrupamento || null}/${this.dataIni || null}/${
            this.dataFim || null
          }/${null}/${this.tipo || null}/${this.status || null}`,
          {
            params: {
              page,
            },
          }
        )
        .then(response => {
          const dados = response.body.dados

          if (dados.turmas_teoricas.data.length < 1) {
            this.toast('Nenhum resultado encontrado!')

            return
          }

          this.turmas = dados.turmas_teoricas.data

          this.paginationData = {
            currentPage: dados.turmas_teoricas.current_page,
            lastPage: dados.turmas_teoricas.last_page,
            total: dados.turmas_teoricas.total,
          }
        })
        .catch(err => {
          this.toast(err.body.mensagem)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        this.fetchTurmas()
      }
    },
    validateInputs() {
      if (this.dataIni) {
        if (!this.dataFim) {
          this.toast('Preencha todos os campos de data.')
          return false
        }

        if (new Date(this.dataIni) > new Date(this.dataFim)) {
          this.toast('A data inicial deve ser menor que a data final.')
          return false
        }
      }

      if (this.dataFim && !this.dataIni) {
        this.toast('Preencha todos os campos de data.')
        return false
      }

      return true
    },
    async updateTurmas() {
      if (!this.data) {
        this.toast('Preencha a data para atualizar as turmas.')

        return
      }

      this.loading = true

      await this.$http
        .get(`${urlApi}/getran/atualizar/turmas/${this.data}`)
        .then(response => {
          console.log(response)
        })
        .catch(err => {
          this.toast(err.body.mensagem)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openInfoModal(id) {
      this.$refs.infoModal.open(id)
    },
    openExportModal() {
      this.$refs.exportModal.open()
    },
    async submitExport(e) {
      this.exportLoading = true

      await this.$http
        .get(`${urlApiV2}/aulas/teoricas/turmas/consultar/relatorio/agrupamentos`, {
          params: {
            ...this.filters,
            type: e.format,
          },
        })
        .then(response => {
          if (e.format === 'pdf') {
            _export.downloadPDF(response.body.data, 'agrupamentos')
          } else {
            _export.downloadCSV(response.body.data, 'agrupamentos')
          }
        })
        .catch(err => {
          this.toast('Erro ao exportar o arquivo.')
        })
        .finally(() => {
          this.exportLoading = false

          this.$refs.exportModal.close()
        })
    },
    clearInputs() {
      this.data = ''
      this.agrupamento = ''
      this.dataIni = ''
      this.dataFim = ''
      this.tipo = ''
      this.status = ''
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.turmas-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .header {
    form {
      display: flex;
      align-items: flex-end;
      gap: 1rem;
    }
  }

  > form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-data {
          max-width: 22.5rem;
        }

        > div {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ececec;
        }

        &:not(:last-child) {
          border-right: 1px solid #ececec;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
